<app-header headerText="Recuperación De Préstamos"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true [selectedIndex]="selectedIndex">

    <mat-tab>
  
      <ng-template mat-tab-label>
        <mat-icon>add</mat-icon>
        Crear Nuevo<br>Parámetro
      </ng-template>
  
      <div>
  
        <div class="row pt-5">
  
          <div class="col-md-4">
            <mat-form-field>
              <input matInput placeholder="Semana(s):" type="number" [(ngModel)]="installment.weeks" #weeksControl="ngModel"
                min="1" [min]="1" [max]="100000" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required>
              <mat-error *ngIf="weeksControl?.errors?.required">Es necesario especificar el número de semanas.</mat-error>
              <mat-error *ngIf="weeksControl?.errors?.min">El número debe de ser mayor a 1.</mat-error>
              <mat-error *ngIf="weeksControl?.errors?.max">El número debe de ser menor a 100000.</mat-error>
            </mat-form-field>
          </div>
  
          <div class="col-md-4">
            <mat-form-field>
              <input matInput placeholder="Catorcena(s):" type="number" [(ngModel)]="installment.biWeeks" #biWeeksControl="ngModel"
                min="1" [min]="1" [max]="100000" onkeypress="return event.charCode >= 48 && event.charCode <= 57" required>
              <mat-error *ngIf="biWeeksControl?.errors?.required">Es necesario especificar el número de catorcenas.</mat-error>
              <mat-error *ngIf="biWeeksControl?.errors?.min">El número debe de ser mayor a 1.</mat-error>
              <mat-error *ngIf="biWeeksControl?.errors?.max">El número debe de ser menor a 100000.</mat-error>
            </mat-form-field>
          </div>
  
          <div class="col-md-4">
            <mat-form-field>
              <input matInput placeholder="Mes(es):" type="number" [(ngModel)]="installment.months" min="1" [min]="1"
                [max]="100000" #monthsControl="ngModel" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                required>
              <mat-error *ngIf="monthsControl?.errors?.required">Es necesario especificar el número de meses.</mat-error>
              <mat-error *ngIf="monthsControl?.errors?.min">El número debe de ser mayor a 1.</mat-error>
              <mat-error *ngIf="monthsControl?.errors?.max">El número debe de ser menor a 100000.</mat-error>
            </mat-form-field>
          </div>
  
        </div>
  
        <div class="row">
          <div class="col-md-4 offset-md-8 center-vertically">
            <button class="btn-block" mat-raised-button color="primary" (click)="addInstallments()">Añadir</button>
          </div>
        </div>
  
        <div class="row mt-5" *ngIf="installments && installments.length > 0">
  
          <div class="col-md-12">
  
            <mat-table #installmentsTable class="table" [dataSource]="installments">
  
              <ng-container matColumnDef="installmentID">
                <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.installmentID}} </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="weeks">
                <mat-header-cell mat-header-cell *matHeaderCellDef> Semana(s) </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.weeks}} </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="biWeeks">
                <mat-header-cell mat-header-cell *matHeaderCellDef> Catorcena(s) </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.biWeeks}} </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="months">
                <mat-header-cell mat-header-cell *matHeaderCellDef> Mes(es) </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.months}} </mat-cell>
              </ng-container>
  
              <ng-container matColumnDef="delete" class="center-text">
                <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
                <mat-cell *matCellDef="let index = index">
                  <button mat-icon-button color="warn" (click)="deleteInstallments(index)">
                    <mat-icon aria-label="Delete">delete_outline</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
  
              <mat-header-row mat-header-row *matHeaderRowDef="displayedInstallmentsColumns"></mat-header-row>
              <mat-row mat-row *matRowDef="let row; columns: displayedInstallmentsColumns;"></mat-row>
            </mat-table>
  
          </div>
  
        </div>
  
      </div>
  
      <div class="row my-4">
  
        <div class="col-md-4 offset-md-4">
          <button class="btn btn-block btn-outline-secondary" (click)="cancelChanges();">Cancelar</button>
        </div>
  
        <div class="col-md-4">
          <button class="btn btn-block btn-primary" (click)="savePeriod()">Guardar Cambios</button>
        </div>
  
      </div>
  
    </mat-tab>
  
  </mat-tab-group>